var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrockenImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37678"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 139482",
    fill: "#f5f6f8",
    d: "M0 0h206v128H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37677"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37675",
    fill: "#c3cbd7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44569",
    d: "M130.293 102.52H75.699a1.533 1.533 0 0 0-.3-.125 8.6 8.6 0 0 1-6.883-5.838c-.2-.542-.31-1.118-.461-1.679V40.296c.036-.055.1-.108.1-.166a8.86 8.86 0 0 1 9.132-7.5c17.146.064 34.293.021 51.439.033a10.756 10.756 0 0 1 2.366.224 8.67 8.67 0 0 1 6.838 8.766q.008 21.212 0 42.425c0 3.228.02 6.457-.006 9.685a8.7 8.7 0 0 1-5.949 8.294c-.545.188-1.118.31-1.682.463Zm3.249-32.5c.013-.293.026-.444.026-.595V41.66a4.388 4.388 0 0 0-4.75-4.639H77.166a4.4 4.4 0 0 0-4.738 4.72q-.005 21.659 0 43.319c0 .191.021.382.039.686l17.316-15.87 9.078 8.764 21.609-21.967Zm-31.626 11.883c.071.083.166.208.276.319q7.689 7.789 15.392 15.565a1.371 1.371 0 0 0 .88.351c3.433.024 6.866.017 10.3.015a4.418 4.418 0 0 0 4.809-4.784c0-5.478.009-10.956-.018-16.433a1.653 1.653 0 0 0-.437-1.05q-6.048-6.1-12.14-12.163c-.157-.156-.325-.3-.445-.412Zm9.658 16.25L89.709 76.281c-.181.155-.4.341-.621.534-5.2 4.654-10.382 9.327-15.613 13.944a2.822 2.822 0 0 0-1.078 2.429c.074 3.226 1.766 4.966 4.994 4.966h34.181Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44575",
    d: "M94.259 50.096a8.733 8.733 0 1 1-8.741-8.706 8.749 8.749 0 0 1 8.741 8.706Zm-4.371.034a4.362 4.362 0 1 0-4.406 4.352 4.4 4.4 0 0 0 4.406-4.352Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 5968",
    transform: "translate(121 25)",
    fill: "#f5f6f8",
    stroke: "#f5e2a8",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37676",
    fill: "#f5e2a8",
    transform: "translate(585 -1289)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 139483",
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "translate(-451 1321)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 139484",
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "translate(-451 1333)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrockenImage);
export default __webpack_public_path__ + "static/media/Brocken_Image.3b68308478d9244695fcf385a883d3a5.svg";
export { ForwardRef as ReactComponent };